module.exports = __webpack_public_path__ + "static/media/25-1.19d03e56.mp3";